export default "__VITE_ASSET__D8fO8Ru5__"